// extracted by mini-css-extract-plugin
export default {"item":"PunchupAutoRefreshToggle_item__LT0kv","label":"PunchupAutoRefreshToggle_label__X0q-O punchupTextMeta","help":"PunchupAutoRefreshToggle_help__v+kD2"};